
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zM13.186 7.5v5.486h1.828v1.828H9.53v3.657H7.7v5.486h5.486v-5.486h-1.829v-1.828h4.418c.099.016.2.016.298 0H20.5v1.828h-1.829v5.486h5.486v-5.486H22.33v-3.657h-5.486v-1.828h1.828V7.5h-5.485z"}})])
          )
        }
      }
    